var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFeatureTileIcon02 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M21 23h22v18H21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 28h12M26 32h12M26 36h5",
    stroke: "#ACADFF"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFeatureTileIcon02);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/feature-tile-icon-02.469356592c7ce3b1abf53cca85e82fee.svg";